export default __webpack_public_path__ + "static/media/icon_faction_company.0126e72e.png";